import { GraduationCapIcon, LogOutIcon, UsersIcon } from 'lucide-react';

import { useSession } from '@/components/auth/user-provider';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

/**
 * Minimal signed-in home for parent and student roles.
 * Dedicated portals are out of scope for this release.
 */
export function AccountLandingPage() {
  const { session, signOut } = useSession();

  if (session.status !== 'signedIn') {
    return null;
  }

  const { user } = session;
  const roleLabel = user.role === 'parent' ? 'Parent' : user.role === 'student' ? 'Student' : user.role;

  return (
    <div className="flex flex-1 items-center justify-center p-4 md:p-8">
      <Card className="border-border/80 w-full max-w-lg shadow-sm">
        <CardHeader className="items-center space-y-3 text-center">
          <span className="bg-primary text-primary-foreground ring-primary/20 flex size-14 items-center justify-center rounded-2xl shadow-sm ring-4">
            {user.role === 'student' ? (
              <GraduationCapIcon className="size-7" aria-hidden />
            ) : (
              <UsersIcon className="size-7" aria-hidden />
            )}
          </span>
          <div className="flex flex-col items-center gap-2">
            <Badge variant="secondary" className="capitalize">
              {roleLabel}
            </Badge>
            <CardTitle className="text-xl">Welcome, {user.name}</CardTitle>
          </div>
          <CardDescription className="text-base">
            You are signed in to School Attendance. A dedicated {roleLabel.toLowerCase()} portal is
            not available yet — check back later, or contact your school if you need help with an
            event.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-3">
          {user.email ? (
            <p className="text-muted-foreground text-center text-sm">{user.email}</p>
          ) : null}
          <Button variant="outline" onClick={() => signOut()}>
            <LogOutIcon /> Sign out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
